<template>
  <q-select
    v-model="model"
    v-bind="FIELD_CHROME.form"
    dense
    emit-value
    dropdown-icon="keyboard_arrow_down"
    map-options
    option-value="value"
    option-label="label"
    :options="filteredOptions"
    use-input
    hide-selected
    fill-input
    input-debounce="0"
    clearable
    popup-content-class="country-select-menu"
    @filter="onFilter"
  />
</template>

<script setup>
  import { ref } from 'vue'

  import { COUNTRY_OPTIONS } from 'src/assets/jsons/countries'
  import { FIELD_CHROME } from 'src/services/consts/app.const'

  const model = defineModel({ type: String, default: null })

  const filteredOptions = ref(COUNTRY_OPTIONS)

  function onFilter(val, update) {
    update(() => {
      const needle = val.toLowerCase()
      filteredOptions.value = needle
        ? COUNTRY_OPTIONS.filter(
            (o) =>
              o.label.toLowerCase().includes(needle) ||
              o.value.toLowerCase().includes(needle) ||
              o.alpha3.toLowerCase().includes(needle)
          )
        : COUNTRY_OPTIONS
    })
  }
</script>
